import type { ComponentProps } from "react";
import type { MenuItemProps } from "react-aria-components";

import { Menu2 } from "@/ui2/molecules/Menu";

export function CosignHistoryMenu({
  className,
  onPress,
  testId,
}: Pick<ComponentProps<"button">, "className"> &
  Required<Pick<MenuItemProps, "onPress">> &
  Pick<ComponentProps<typeof Menu2>, "testId">) {
  return (
    <Menu2
      classNameTrigger={className}
      items={[{ id: "session-history", label: "Session History", onPress }]}
      placement="bottom right"
      testId={testId}
    />
  );
}
